export default {
  error: {
    tooBig: 'حجم الملف مرتفع جدًا (الحد الأقصى: {maxSize} {unit})'
  }
}
